<template>
    <div>
        <h3>Service Details <span v-if="service.custom.Location" class="sau-font">- {{ service.custom.Location }}</span></h3>
        <div class="row pb-6">
            <div class="col">
                <div class="sau-bx bx-pad">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <ul class="sau-list-display">
                                <li v-for="(val, key) in this.col1" :key="key">
                                    <h5>{{ val[0] }}
                                        <!-- provide link for Data Center field -->
                                        <span v-if="val[0] == 'Data Centre' && getDataCenterLink(val[1])" class="sau-font sm text-center">
                                            <i class="fas fa-link sau-font-color blue"></i>
                                            <a :href="getDataCenterLink(val[1])" target="_blank">View Details</a>
                                        </span>
                                    </h5>
                                    <p>{{ val[1] }}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <ul class="sau-list-display">
                                <li v-for="(val, key) in this.col2" :key="key">
                                    <h5>{{ val[0] }}
                                        <!-- provide link for Data Center field -->
                                        <span v-if="val[0] == 'Data Centre' && getDataCenterLink(val[1])" class="sau-font sm text-center">
                                            <i class="fas fa-link sau-font-color blue"></i>
                                            <a :href="getDataCenterLink(val[1])" target="_blank">About</a>
                                        </span>
                                    </h5>
                                    <p>{{ val[1] }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <h3>Network <span class="sau-font sm text-center"><i class="fas fa-link sau-font-color blue"></i><a :href="networkLink">View Usage</a></span></h3>
        <div class="row">
            <div class="col">
                <div class="sau-bx bx-pad">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <ul class="sau-list-display">
                                <li>
                                    <h5>Primary IP Address</h5>
                                    <p>{{ service.dedicatedip || service.ipaddress || service.serverhostname || 'Not Set' }}</p>
                                </li>
                                <li>
                                    <h5>Netmask</h5>
                                    <p>{{ displayValue('subnet_mask') }}</p>
                                </li>
                                <li v-if="service.custom.Bandwidth">
                                    <h5>Bandwidth</h5>
                                    <p>{{ service.custom.Bandwidth }}</p>
                                </li>
                                <li v-if="service.custom.Quota">
                                    <h5>Quota</h5>
                                    <p>{{ service.custom.Quota }}</p>
                                </li>
                            </ul>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <ul class="sau-list-display">
                                <li>
                                    <h5>Additional IP Addresses</h5>
                                    <p v-if="service['network']">
                                        {{ service['network']['additional_ips'].length }} additional IP's
                                        <button v-b-modal.ip-modal class="btn btn-primary float-right text-white py-1" style="font-size: 0.8rem;">View</button>
                                    </p>
                                    <p v-else>Not Set</p>
                                </li>
                                <li>
                                    <h5>Gateway</h5>
                                    <p>{{  displayValue('gateway') }}</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="(service.isFullRack || service.isHalfRackLockable) && service.power">
            <h3 id="power-usage" class="mt-6">Power Usage</h3>
            <div class="row pb-6">
                <div class="col">
                    <div class="sau-bx bx-pad">
                        <div class="row">
                            <div class="col">
                                <div class="text-right">
                                    <label>
                                        <p class="mb-0">Choose Month</p>
                                        <select id="date-select" v-model="selectedPowerDataGroup" class="border border-solid p-1 px-2">
                                            <option v-for="(group, index) in powerDataGroups" :key="`group-${index}`" :value="group">{{ group }}</option>
                                        </select>
                                    </label>
                                </div>

                                <colocation-power-chart style="height: 300px" :chart-data="powerData"></colocation-power-chart>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <b-modal id="ip-modal"
                centered
                title="IP Addresses"
                hide-footer
                cancel-variant="link"
                ref="modalEditIp">
                <div class="row">
                    <div class="col">

                        <template v-if="service.ipaddress">
                            <h5>Primary IP:</h5>
                            <p>{{ service.dedicatedip || service.ipaddress || service.serverhostname || 'Not Set' }}</p>
                        </template>

                        <div v-if="service['network']['additional_ips'].length" class="mb-4">
                            <h5>Additional IP's:</h5>
                            <p class="mb-0" v-for="(ip, index) in service['network']['additional_ips']" :key="index">{{ ip.ip_address }}</p>
                        </div>

                        <div v-if="service.assignedips.length" class="mb-4">
                            <h5>Assigned IP's:</h5>
                            <p class="mb-0" v-for="(ip, index) in filteredIps" :key="index">{{ ip }}</p>
                        </div>

                    </div>
                </div>
        </b-modal>
    </div>
</template>

<script>
import ColocationPowerChart from './ColocationPowerChart';

export default {
    components: { ColocationPowerChart },
    props: ['service'],
    data() {
        return {
            specificFields: [
                'Location',
                'Bandwidth',
                'Quota'
            ],
            addresses: {
                'Sydney - SY3' : 'https://www.equinix.com.au/locations/australia-colocation/sydney-data-centers/sy3/',
                'Sydney - SY4' : 'https://www.equinix.com.au/locations/australia-colocation/sydney-data-centers/sy4/',
            },
            popover: 'Data Center Link',
            filtered: [],
            formatted: [],
            col1: [],
            col2: [],
            selectedPowerDataGroup: '',
        }
    },
    created() {
        this.formatDetails();
        // Set the most recent month as the default
        this.selectedPowerDataGroup = this.powerDataGroups[0];
    },
    methods: {
        formatDetails() {
            let x = 1;
            /** Add fields we want to display to custom */
            this.service.custom['Data Centre'] = this.service.network.data_center_location.name;
            this.service.custom['Rack'] = this.service.network.loc_rack;
            this.service.custom['Area'] = this.service.network.loc_cage;
            this.service.custom['Position'] = this.service.network.loc_position;
            _.forIn(this.service.custom, function(val, key) {
                if(!this.specificFields.includes(key)) {
                    if(x % 2) {
                        this.col1.push([key, val]);
                    } else {
                        this.col2.push([key, val]);
                    }
                    x++;
                }
            }.bind(this));
            this.formatted = _.chunk(this.filtered, Math.ceil(this.filtered.length / 2));
        },
        displayValue(field) {
            if(!this.service['network']) {
                return 'Not Set';
            }
            return this.service['network'][field] ? this.service['network'][field] : 'Not Set';
        },
        specificField(field) {
            return this.specificFields.includes(field);
        },
        getDataCenterLink(field) {
            return this.addresses[field] ? this.addresses[field] : '';
        }
    },
    computed: {
        ipAddress() {
            /**
             * Return DedicatedIP : ServerIP : ServerHostName : 'Not Set'
             */
            return this.service['dedicatedip'] ? this.service['dedicatedip'] :
                    this.service['serverip'] ? this.service['serverip'] :
                    this.service['serverhostname'] ? this.service['serverhostname'] : 'Not Set';
        },
        filteredIps() {
            return this.service.assignedips.replace(/[\n\r]+/g, ' ').split(' ');
        },

        powerData() {
            return {
                labels: this.filteredPowerData.map((item) => item.record_date).reverse(),
                datasets: [
                    {
                        label: 'kVA',
                        backgroundColor: '#00ce7d',
                        lineTension: 0,
                        data: this.filteredPowerData.map((item) => item.kva).reverse()
                    }
                ]
            }
        },

        powerDataGroups() {
            return Object.keys(this.service.power);
        },

        filteredPowerData() {
            return this.service.power[this.selectedPowerDataGroup];
        },

        chartTitle() {
            return new Intl.DateTimeFormat('en-AU', { month: 'long', year: 'numeric' }).format(new Date(this.selectedPowerDataGroup));
        }

    }
}
</script>

<style lang="scss">
    #ip-modal {
        .row {
            max-height: 50vh;
            overflow-y: scroll;
        }
    }
    .sau-border-bottom {
        border-bottom: solid 1px #e5e5e5;
    }
</style>
<style lang="scss" scoped>
    select {
        -webkit-appearance: auto !important;
        -moz-appearance: auto !important;
    }
</style>
